import Tr from "translations/Translations";
import Loading from "components/Loading";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import Dialog from "components/Dialog";
import React, {useEffect, useMemo, useState} from "react";
import {connect} from "react-redux";
import {withStyles} from "@material-ui/core";
import AuditTaskService from "../service/AuditTaskService";
import moment from "moment";
import DateFormats from "constants/DateFormats";
import {LABELS} from "../constants/AuditTaskAllowedObjectType";
import {AUDIT_TASK_TYPE_LABELS} from "../constants/AuditTaskType";
import MultiButton, {createButton} from "../../../../components/popup/components/MultiButton";

const style = theme => ({
    root: {
        padding: theme.spacing(2)
    },
    user: {
        width: 150,
        wordBreak: 'normal'
    },
    action: {
        width: 100
    },
    field: {
        width: 200
    },
    date: {
        width: 150
    },
    cell: {
        padding: theme.spacing(1),
    },
    buttons: {
        paddingBottom: theme.spacing(1)
    }
})

function AuditTaskHistoryPopup({
    taskId,
    open,
    onClose,
    auditTaskHistory = {list: []},
    classes
}) {

    const [loading, setLoading] = useState(false);
    const [working, setWorking] = useState(false);

    const items = auditTaskHistory.list;

    useEffect(() => {
        if (open) {
            setLoading(true);
            AuditTaskService.getHistory(taskId).then(() => setLoading(false));
        } else {
            AuditTaskService.clearHistory();
        }
    }, [open, taskId]);

    const getHeaders = () => {
        if (!items) return;
        const headers = [];
        headers.push(Tr('audit_task_history_header_user'));
        headers.push(Tr('audit_task_history_header_action'));
        headers.push(Tr('audit_task_history_header_field'));
        headers.push(Tr('audit_task_history_header_changes'));
        headers.push(Tr('audit_task_history_header_date'));

        return headers;
    }

    const headers = getHeaders();

    const getHeaderClasses = () => {
        if (!items) return;
        const headers = [];
        headers.push(classes.user);
        headers.push(classes.action);
        headers.push(classes.field);
        headers.push(undefined);
        headers.push(classes.date);

        return headers;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const headerClasses = useMemo(getHeaderClasses, [items]);

    const getChangeCell = (item) => {
        if (!!item.oldValue && !!item.newValue) {
            return (<>{`${Tr('audit_task_history_from')}: ${parseValue(item.oldValue, item.field)}`}<br/>{`${Tr('audit_task_history_to')}: ${parseValue(item.newValue, item.field)}`}</>);
        } else if (!!item.oldValue) {
            return parseValue(item.oldValue, item.field);
        } else {
            return parseValue(item.newValue, item.field);
        }
    }

    const parseValue = (value, field) => {
        if ('startDate' === field || 'endDate' === field) {
            return moment(value).format(DateFormats.DATETIME_FORMAT);
        } else if ('allowedObjects' === field) {
            const parts = value.split(';');
            const objectType = LABELS[parts.shift()].toLowerCase();
            return objectType + ' ' + parts.join('');
        } else if ('type' === field) {
            return AUDIT_TASK_TYPE_LABELS[value];
        } else {
            return value;
        }
    }

    const getRows = () => {
        if (!items) return;
        const rows = items.map((item) => {
            const row = [];
            row.push(item.user.firstName + ' ' + item.user.lastName);
            row.push(!item.oldValue ? Tr('audit_task_history_add') : (!item.newValue ? Tr('audit_task_history_delete') : Tr('audit_task_history_change')));
            row.push(Tr('audit_task_history_field_' + item.field));
            row.push(getChangeCell(item));
            row.push(moment(item.dateInserted).format(DateFormats.DATETIME_FORMAT));
            return row;
        });
        return rows;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const rows = useMemo(getRows, [items]);

    const getActions = () => {
        const buttons = [];
        buttons.push(createButton(Tr('download_print'), printHistory, undefined, working));
        return <MultiButton buttons={buttons} className={classes.buttons} />;
    }

    const printHistory = () => {
        setWorking(true);
        AuditTaskService.printHistory(taskId).then(() => setWorking(false));
    }

    return (
        <Dialog title={Tr('change_history')} open={open} maxWidth={'lg'} onClose={onClose} dialogActions={getActions()}>
            {loading ?
                <Loading/>
                :
                <SimpleTable
                    items={rows}
                    headers={headers}
                    columnClasses={headerClasses}
                    cellClassName={classes.cell}
                />
            }
        </Dialog>
    )
}

export default connect((state) => ({
    auditTaskHistory: state.resources.auditTaskHistory
}), {})(withStyles(style)(AuditTaskHistoryPopup));